module.exports = __webpack_public_path__ + "media/images/markt-66dafb35657729896e6328f03b496e37.JPG";